export default {
  title: 'Utwórz nowe hasło',
  description: 'Utwórz nowe hasło do swojego konta.',
  form: {
    new_password: {
      label: 'Nowe hasło',
      placeholder: 'Wprowadź hasło',
      requirements: 'Hasło musi zawierać 8 znaków, wielką literę i cyfrę',
    },
    confirm_password: {
      label: 'Potwierdzenie nowego hasła',
      placeholder: 'Potwierdź hasło',
    },
    error_messages: {
      missing_info: 'Brakujące informacje',
    },
  },
  buttons: {
    update_password: 'Zaktualizuj hasło',
  },
};
